import { Bell, Menu } from "lucide-react";
import { Link } from "react-router-dom";
import { useScrollDirection } from "@/shared/hooks/use-scroll-direction";
import { ModePills } from "./ModePills";
import { cn } from "@/shared/utils/cn";
import { IconButton } from "@/shared/ui/IconButton";

export function TopBar({ onOpenDrawer }: { onOpenDrawer: () => void }) {
  const { scrolled, hidden } = useScrollDirection();
  return (
    <header
      data-testid="top-bar"
      className={cn(
        "fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-md z-40 transition-all duration-300",
        scrolled ? "glass-strong border-b border-white/[0.08]" : "bg-gradient-to-b from-velvet/90 via-velvet/40 to-transparent",
        hidden ? "-translate-y-full" : "translate-y-0",
      )}
    >
      <div className="flex items-center justify-between px-4 py-3">
        <button onClick={onOpenDrawer} aria-label="Open menu" className="flex items-center gap-2 active:scale-95 transition-transform">
          <Menu className="w-5 h-5 text-white/70" />
          <span className="font-serif italic text-lg text-gradient-rose tracking-widest">PikPok</span>
        </button>
        <ModePills />
        <Link to="/instaflix/notifications" aria-label="Notifications">
          <IconButton size="sm">
            <Bell className="w-4 h-4" />
          </IconButton>
        </Link>
      </div>
    </header>
  );
}
